import { useT } from '_metronic/i18n/Metronici18n'
import { TriagemRiscoBadge } from '../../../../../../components/TriagemRisco/TriagemRiscoBadge'
import { AtendimentoList } from '../../../../atendimento/core/_models'
import styles from './RiscoTriagemCell.module.css'

/**
 * Célula de risco da fila do médico.
 *
 * - Com cor: selo de cor viva e, abaixo, os avisos (reavaliação pendente, protocolo em
 *   validação) numa linha de texto de apoio separada por `·`; o `title` traz o texto completo.
 * - Sem cor (atendimento sem triagem ou `corFila` vazia): rótulo "Sem triagem" com borda
 *   tracejada — neutro, para não competir com as cores clínicas, mas explícito (célula em branco
 *   seria ambígua: sem triagem, carregando ou erro).
 */
export const RiscoTriagemCell = ({ atendimento }: { atendimento: AtendimentoList }) => {
  const { t } = useT()
  const triagem = atendimento.triagem

  if (!triagem?.corFila) {
    return (
      <span className={styles.semTriagem} title={t('triagem.fila.sem_triagem_titulo')}>
        {t('triagem.fila.sem_triagem')}
      </span>
    )
  }

  const avisos = [
    triagem.corMantida && {
      curto: t('triagem.reavaliacao_pendente'),
      completo: t('triagem.aguardando_revisao'),
    },
    triagem.protocoloEmValidacao && {
      curto: t('triagem.protocolo_em_validacao'),
      completo: t('triagem.protocolo_em_validacao'),
    },
  ].filter((aviso): aviso is { curto: string; completo: string } => Boolean(aviso))

  return (
    <div className={styles.celula}>
      <TriagemRiscoBadge cor={triagem.corFila} titulo={t('triagem.rotulo.risco')} />
      {avisos.length > 0 && (
        <span className={styles.avisos} title={avisos.map((aviso) => aviso.completo).join(' · ')}>
          {avisos.map((aviso) => aviso.curto).join(' · ')}
        </span>
      )}
    </div>
  )
}
